import { HeightIcon, WidthIcon } from '@radix-ui/react-icons';

import { ColorPicker } from '../../../../../primitives/color-picker';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { InputNumberWithSteps } from '../controls/input-number-with-steps';
import { BorderRadius } from '../controls/border-radius';

import { cn } from '../../../../../utils/cn';

import { EMAIL_COLORS } from '../../constants/colors';

const IMAGE_MIN_SIZE = 16;
const IMAGE_MAX_SIZE = 370;
const IMAGE_SIZE_STEPS = [IMAGE_MIN_SIZE, 32, 64, 128, 192, 256, 320, IMAGE_MAX_SIZE];

type AppearanceProps = {
  backgroundColor?: string;
  borderRadius?: number | null;
  className?: string;
  height?: string;
  width?: string;
  onBackgroundColorChange?: (backgroundColor?: string | null) => void;
  onBorderRadiusChange?: (borderRadius: number | null) => void;
  onHeightChange?: (height: string) => void;
  onWidthChange?: (width: string) => void;
};

export function Appearance({
  backgroundColor,
  borderRadius,
  className,
  height,
  width,
  onBackgroundColorChange,
  onBorderRadiusChange,
  onHeightChange,
  onWidthChange,
}: AppearanceProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-xs font-medium">Apariencia</p>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1">
        <div>
          <div className="flex items-center gap-1">
            <WidthIcon className="size-4" />
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              Ancho
            </LabelWithoutRef>
          </div>
          <InputNumberWithSteps
            id="appearance-image-width"
            max={IMAGE_MAX_SIZE}
            min={IMAGE_MIN_SIZE}
            placeholder="Auto"
            steps={IMAGE_SIZE_STEPS}
            value={width === '' || width === undefined ? null : Number(width)}
            onChange={(value) => onWidthChange?.(value === null ? '' : String(value))}
          />
        </div>
        <div>
          <div className="flex items-center gap-1">
            <HeightIcon className="size-4" />
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              Alto
            </LabelWithoutRef>
          </div>
          <InputNumberWithSteps
            id="appearance-image-height"
            max={IMAGE_MAX_SIZE}
            min={IMAGE_MIN_SIZE}
            placeholder="Auto"
            steps={IMAGE_SIZE_STEPS}
            value={height === '' || height === undefined ? null : Number(height)}
            onChange={(value) => onHeightChange?.(value === null ? '' : String(value))}
          />
        </div>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Fondo
          </LabelWithoutRef>
          <ColorPicker
            colors={EMAIL_COLORS}
            isCleanColorVisible
            noneColorLabel="Sin personalizar"
            value={backgroundColor}
            onValueChange={(value) => onBackgroundColorChange?.(value ?? null)}
          />
        </div>
        <BorderRadius unit="%" value={borderRadius} onChange={onBorderRadiusChange} />
      </div>
    </div>
  );
}
